import { createApp } from 'vue'
// import vConsole from 'vconsole'
import App from './App.vue'
import router from './router'
import store from './store'
import VantComponents from './components/vantComp'
import EventEmitter from 'wolfy87-eventemitter'
import mobileNativeSDK from './assets/js/mobileNativeSDK'
import { xesLog } from './utils/sensors'
import XesLoggerSDK from '@xes/xes_fe_log'
import { registerFnHandler } from '@/utils/registerFnHandler'
import { isIOS } from '@/assets/js/utils'
import { isXesBook } from '@/core'
console.log('当前是不是app==>', isXesBook)
const app = createApp(App)
app.provide('$xesLog', xesLog)
app.config.globalProperties.$xesLog = xesLog

// 注册客户端通知h5更新token的方法
registerFnHandler('updateToken', (data = {}) => {
  const { token = '' } = data as { token: string }
  console.log('收到新的token', token)
  if (token) {
    window.localStorage.setItem('tal_token', token)
    const clientCommonMessage = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
    localStorage.setItem('clientCommonMessage', JSON.stringify({ ...clientCommonMessage, token }))
  }
  return {
    message: `更新token成功`,
    token
  }
})
;(window as any).$eventBus = new EventEmitter()
window['$mobileNativeSDK'] = mobileNativeSDK
xesLog.initCommonParam()
const rmKickBackFn = (e) => {
  document.body.scrollTop = 0
}
router.beforeEach((to, from, next) => {
  // 去掉ios的回弹效果
  if (isIOS) {
    // document.body.removeEventListener('touchmove',rmKickBackFn)

    let bodyStyle = document.body.style
    let htmlStyle = document.getElementsByTagName('html')[0].style
    if (['/task-dot', '/task-dot-half-screen'].includes(to.path)) {
      document.body.addEventListener('touchmove', rmKickBackFn)
      htmlStyle.position = 'fixed'
      htmlStyle.top = '0px'
      htmlStyle.bottom = '0px'
      htmlStyle.left = '0px'
      htmlStyle.right = '0px'
      bodyStyle.position = 'fixed'
      bodyStyle.top = '0px'
      bodyStyle.bottom = '0px'
      bodyStyle.left = '0px'
      bodyStyle.right = '0px'
    } else {
      bodyStyle.position = 'static'
      htmlStyle.position = 'static'
    }
  }
  localStorage.setItem('lastPagePath', from.path)
  // 保持原来的逻辑
  if (to.meta.title) {
    ;(document as any).title = to.meta.title
  } else {
    if (!navigator.userAgent.toLowerCase().includes('xes-book')) {
      ;(document as any).title = '好未来图书'
    }
  }
  next()
})

// 按需加载vant组建
VantComponents.forEach((vant) => app.use(vant))

process.env.VUE_APP_PREPATH === 'production' &&
  app.use(XesLoggerSDK, {
    common: {
      eventid: 'webIbook'
    },
    loadMsg: {
      open: true // pv的上报开关，
    },
    network: {
      open: true, //ajax日志监控开关
      sample: 1 //ajax日志监控采样率
    },
    runtime: {
      open: true, //运行时JS报错开关
      sample: 1 //运行时JS报错采样率
    },
    resource: {
      open: true, //运行时资源报错开关
      sample: 1 //运行时资源报错采样率
    },
    performance: {
      open: true, //运行时性能日志开关
      sample: 1 //运行时性能日志采样率
    },
    vue: {
      errorHandler: true //是否捕获Vue抛出的错误
    },
    appid: '1005082'
    // appid:'1005082,1014721'
  } as any)
app.use(store).use(router).mount('#app')
